import '../styles/globals.scss'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import Head from 'next/head'
import Router, { useRouter } from 'next/router'
import { AppProps } from 'next/app'
import { useState, useEffect, useCallback } from 'react'
import AppProgressBar from '../components/core/app-progress-bar/AppProgressBar'
import { useIntercomWindow } from '../utils/hooks.util'
import CookieModal from '../components/modals/cookie-modal/CookieModal'
import { useClearCache } from 'react-clear-cache'
import axios from 'axios'
import AppDownloadModal from '../components/modals/app-download-modal'

export default function App({ Component, pageProps }: AppProps) {
  const [loading, setLoading] = useState(false)
  const { isLatestVersion, emptyCacheStorage } = useClearCache()

  const [showDownloadModal, setShowDownloadModal] = useState(true)
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    if (!isLatestVersion) {
      emptyCacheStorage()

      const clearCache = async () => {
        await axios.get('/api/utils/clear-cookies')
        await emptyCacheStorage()
      }
      clearCache()
    }
  }, [emptyCacheStorage, isLatestVersion])

  useIntercomWindow()
  async function SetPageLoader() {
    if (document && document.fullscreenElement) {
      await document.exitFullscreen()
    }
    setLoading(true)
  }

  function ClearPageLoader() {
    setLoading(false)
  }

  const HandleRouterEvents = useCallback(() => {
    Router.events.on('routeChangeStart', SetPageLoader)
    Router.events.on('routeChangeComplete', ClearPageLoader)
    Router.events.on('routeChangeError', ClearPageLoader)
  }, [])

  useEffect(() => {
    HandleRouterEvents()

    return () => {
      Router.events.off('routeChangeStart', SetPageLoader)
      Router.events.off('routeChangeComplete', ClearPageLoader)
      Router.events.off('routeChangeError', ClearPageLoader)
    }
  }, [HandleRouterEvents])
  const router = useRouter()

  // Check if the route is not found (404) and redirect to the homepage
  useEffect(() => {
    if (router.isFallback || router.asPath === '/404') {
      router.push('/origins')
    }
  }, [router.asPath, router.isFallback])

  useEffect(() => {
    const userAgent = navigator.userAgent

    if (userAgent.match(/Android/i)) {
      setShowDownloadModal(true)
      setIsAndroid(true)
      localStorage.setItem('hasDownloaded', 'true')
    } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
      setShowDownloadModal(true)
      setIsAndroid(false)
      localStorage.setItem('hasDownloaded', 'true')
    } else if (userAgent.match(/Macintosh/i)) {
      // Add a specific condition for Macintosh
      setShowDownloadModal(false)
    } else {
      setShowDownloadModal(false)
    }
  }, [])
  useEffect(() => {
    const hasDownloaded = localStorage.getItem('hasDownloaded')
    if (hasDownloaded) {
      setShowDownloadModal(false)
    }
  }, [])

  return (
    <main className={'app_container'}>
      <Head>
        <link rel="icon" type="image/x-icon" href="/favicon.svg" />
      </Head>
      {loading && <AppProgressBar />}
      <Component {...pageProps} />
      <CookieModal />
      <AppDownloadModal
        isOpen={showDownloadModal}
        onRequestClose={() => setShowDownloadModal(false)}
        isAndroid={isAndroid}
      />
      <ToastContainer />
    </main>
  )
}
